import { render, staticRenderFns } from "./IDValidationStep.vue?vue&type=template&id=3eb113f2&scoped=true&"
import script from "./IDValidationStep.vue?vue&type=script&lang=js&"
export * from "./IDValidationStep.vue?vue&type=script&lang=js&"
import style0 from "./IDValidationStep.vue?vue&type=style&index=0&id=3eb113f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb113f2",
  null
  
)

export default component.exports